import { useState } from "react";
import { useTranslate } from "ra-core";
import { Plus, Search, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { TaskCreateSheet } from "./TaskCreateSheet";
import { TasksListContent } from "./TasksListContent";

export const MobileTasksList = () => {
  const translate = useTranslate();
  const [createOpen, setCreateOpen] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const closeSearch = () => {
    setIsSearching(false);
    setSearchQuery("");
  };

  return (
    <>
      <MobileHeader>
        {isSearching ? (
          <>
            <input
              autoFocus
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Поиск..."
              className="flex-1 bg-transparent outline-none text-sm min-w-0"
            />
            <Button variant="ghost" size="icon" onClick={closeSearch} className="shrink-0">
              <X className="h-5 w-5" />
            </Button>
          </>
        ) : (
          <>
            <h1 className="text-lg font-semibold flex-1 truncate">
              {translate("resources.tasks.name", { smart_count: 2 })}
            </h1>
            <Button
              variant="ghost"
              size="icon"
              className="shrink-0"
              onClick={() => setIsSearching(true)}
            >
              <Search className="h-5 w-5" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="shrink-0"
              onClick={() => setCreateOpen(true)}
            >
              <Plus className="h-5 w-5" />
            </Button>
          </>
        )}
      </MobileHeader>
      <TaskCreateSheet open={createOpen} onOpenChange={setCreateOpen} />
      <MobileContent>
        <TasksListContent searchQuery={searchQuery} />
      </MobileContent>
    </>
  );
};
